import { PublicClientApplication } from "@azure/msal-browser";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import { ErrorBoundary } from "@dfp/react-api-core";
import { reactPlugin } from "@dfp/react-app-insights";
import { themeRebranding } from "@dfp/react-mui-theme";
import { ReplicatedHistoryProvider } from "@dfp/react-replicated-history";

import { makeMsalConfig } from ".//makeMsalConfig";
import App from "./App";
import "./i18n/initI18next";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
    },
  },
});

function initializeMsalInstance(msalInstance: PublicClientApplication) {
  msalInstance.initialize().then(() => {
    // Default to using the first account if no account is active on page load
    if (
      !msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length > 0
    ) {
      // Account selection logic is app dependent. Adjust as needed for different use cases.
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]); //
    }

    const container = document.getElementById("root");

    if (!container) {
      throw new Error("DOM root container not found");
    }

    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <AppInsightsContext.Provider value={reactPlugin}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={themeRebranding}>
              <ErrorBoundary>
                <BrowserRouter>
                  <NuqsAdapter>
                    <ReplicatedHistoryProvider>
                      {/* <AppLanguageProvider> */}
                      <App pca={msalInstance} />
                      {/* </AppLanguageProvider> */}
                    </ReplicatedHistoryProvider>
                  </NuqsAdapter>
                </BrowserRouter>
              </ErrorBoundary>
            </ThemeProvider>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </AppInsightsContext.Provider>
      </React.StrictMode>,
    );
  });
}

const msalInstance = new PublicClientApplication(makeMsalConfig());
initializeMsalInstance(msalInstance);
